template = require('./planbar.html.slim')

angular.module('wbComponents').directive 'planbar',
['finance', (finance)  ->
  restrict: 'E'
  replace: true
  scope:
    data: '='
    age: '='
    currentAge: '='
    maxAge: '@'

  templateUrl: template

  link: ($scope, element, attrs) ->
    setWidth = (years) ->
      x = 100*years/$scope.ageRoom
      $scope.width = { width: "#{x}%" }

    setAgeRoom = ->
      $scope.ageRoom = ($scope.maxAge or 100) - $scope.currentAge

    calculateYearsLeft = ->
      if $scope.age isnt undefined
        years = $scope.age - $scope.currentAge
      else
        d = $scope.data
        months = finance.periods(
          finance.cdnMortgageRate(d.interestRate)/12,
          d.payment,
          d.balance)
        if (months/12) > $scope.ageRoom or months is -Infinity or _.isNaN(months)
          years = $scope.ageRoom
        else
          years = Math.ceil(months/12)

      setWidth(years)

    $(window).resize -> calculateYearsLeft()
    $scope.$watch 'data', calculateYearsLeft, true
    $scope.$watch 'currentAge', ->
      setAgeRoom()
      calculateYearsLeft()
    $scope.$watch 'age', ->
      setAgeRoom()
      calculateYearsLeft()
]
